import { withStyles } from '@material-ui/core/styles';
import Badge from '@material-ui/core/Badge';
// @ts-ignore
var BetaBadge = withStyles(function (theme) { return ({
    badge: {
        backgroundColor: 'transparent',
        color: 'red',
        width: 40,
        height: 20,
        right: -35,
        top: -15,
        textTransform: 'uppercase',
        fontSize: '1rem',
    },
    // @ts-ignore
}); })(Badge);
export default BetaBadge;



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/BetaBadge.tsx
// module id = 763
// module chunks = 81